import { createContext } from "react"

export type ThemeType = "dark" | "light"

export const DarkModeContext = createContext<ThemeType>("light")
